export const chatbotRouteDef = [
    {
        path: 'launchbot',
        component: 'LaunchBotComponent',
        data: {
            selector: 'app-launchbot'
        }
    }
]